<template>
  <div class="box box--gray">
    <h4 class="box__title">
      {{ in18['page_shipping_title'] }}
    </h4>

    <div class="form-control form-control--select">
      <select v-model="selectedCountryId" name="country" @change="getShippingMethods">
        <option value="">Select country</option>
        <option v-for="country in countries" :value="country.id" :key="country.id">
          {{ country.title }}
        </option>
      </select>
    </div><!-- Country -->

    <div class="form-control form-control--select" v-if="selectedCountryId">
      <select v-model="selectedShippingMethod" name="service" @change="selectShippingMethod">
        <option value="">Select shipping method</option>
        <option v-for="shippingMethod in shippingMethods" :value="shippingMethod" :key="shippingMethod.id">
          {{ shippingMethod.title }}
        </option>
      </select>
    </div><!-- Shipping method -->

    <form v-if="isShopPostcodeRequired" class="mt-3" @submit.prevent="processPostCode">
      <div class="form__group">
        <input v-model="postcode" class="form-control" type="text" name="postcode" id="postcode">
        <label class="form-label" for="postcode">Postcode</label>
        <svg class="form-control-icon">
          <use href="#form-location"></use>
        </svg>
      </div>
      <button class="btn btn--red btn--block btn--sm">
        Check
      </button>
    </form><!-- Postcode -->

  </div>
</template>

<script>

export default {

  name: "CartShipping",

  props: {
    cart:       Object,
    in18:       {
      type: Object
    },
    inProgress: Boolean
  },
  data() {
    return {
      countries:              [],
      shippingMethods:        [],
      selectedCountryId:      '',
      selectedShippingMethod: null,
      postcode:               ''
    };
  },

  emits: [
    'update-cart',
    'update-in-progress'
  ],

  created() {
    this.getCountries();
  },

  computed: {
    isShopPostcodeRequired() {
      return this.selectedShippingMethod ? this.selectedShippingMethod.type === 'courier' : false;
    }
  },

  methods: {

    getCountries() {
      axios.get('/api/countries').then((response) => {
        this.countries = response.data.countries;
      });
    },

    getShippingMethods() {

      if (this.inProgress) {
        return;
      }

      this.$emit('update-in-progress', true);

      this.shippingMethods = [];
      this.selectedShippingMethod = '';

      axios.post('/api/cart/shipping-address', {
        'country_id': this.selectedCountryId
      }).then((response) => {
        window.toastr.success(response.data.message);
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
      });

      // Assuming you have an API endpoint to fetch shipping methods for the selected country.
      axios.get(`/api/shipping`).then((response) => {
        this.shippingMethods = response.data.shippingMethods;
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
      }).finally(() => {
        this.$emit('update-in-progress', false);
      })
    },

    selectShippingMethod() {

      if (this.inProgress || !this.selectedShippingMethod) {
        return;
      }

      this.$emit('update-in-progress', true);

      axios.post('/api/cart/shipping/' + this.selectedShippingMethod.id)
          .then((response) => {
            window.toastr.success(response.data.message);
            this.$emit('update-cart', response.data.cart);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            this.$emit('update-in-progress', false);
          });
    },

    processPostCode() {

      if (this.inProgress) {
        return;
      }

      this.$emit('update-in-progress', true);

      alert('TODO');

      this.$emit('update-in-progress', false);
    },
  }
};
</script>
